import { IconProps } from "./type";

const WithdrawIcon = ({ className }: IconProps) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.4287 1.78516H24.143"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M6.75807 24.3882L23.7286 7.41763M24.5368 19.5395V6.60951H11.6068"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WithdrawIcon;
